import React, { Component } from 'react';
import classNames from 'classnames';
import { CSSTransitionGroup } from 'react-transition-group';
import onClickOutside from 'react-onclickoutside';
import { transition, findLinkEntity, toggleLink, isValidUrl } from 'lib/helpers';

@onClickOutside
export class EditLinkBar extends Component {
	state = {
		actived: false,
		editUrl: null,
		showValidationError: false,
		isValid: false,
		buttonPosition: '50%',
	};

	inputElement = null;

	render() {
		return (
			<CSSTransitionGroup {...transition.slide({ enterPosition: { x: 0, y: 10 } }) }>
				{this.renderContent()}
			</CSSTransitionGroup>
		);
	}

	renderContent() {
		const { actived, editUrl, isValid, showValidationError, buttonPosition } = this.state;
		if (!actived) return null;

		return (
			<div
				className="qa-r-editor-bubble"
				/** 工具栏对这两个事件 preventDefault 了，会影响编辑 */
				onClick={e => e.stopPropagation()}
				onMouseDown={e => e.stopPropagation()}>
				<div
					className="qa-r-editor-bubble-inner"
					style={{
						/* 箭头位置指向按钮 */
						left: buttonPosition
					}}>
					<input
						ref={input => this.inputElement = input}
						// autoFocus
						className={classNames("qa-r-editor-bubble-input", {
							error: showValidationError && !isValid,
						})}
						type="url"
						value={editUrl || ''}
						onChange={this.update}
						placeholder="https://cloud.tencent.com"
						onInput={evt => evt.stopPropagation()}
						onKeyDown={this.handleKeyDown}
						onKeyUp={evt => evt.stopPropagation()}
					/>
					<div className="qa-r-editor-bubble-btns">
						<button className="qa-r-editor-bubble-btn" onClick={this.save}>插入</button>
						<button className="qa-r-editor-bubble-btn qa-r-editor-bubble-btn-weak" onClick={this.dismiss}>取消</button>
					</div>
					{(showValidationError && !editUrl) && <div className="qa-r-editor-bubble-tip error">请输入链接地址</div>}
					{(showValidationError && editUrl && !isValid) && <div className="qa-r-editor-bubble-tip error">请输入合法的链接地址</div>}
				</div>
			</div>
		);
	};

	update = evt => {
		let editUrl = evt.target.value;
		const isValid = isValidUrl(editUrl, true);
		if (isValid && !editUrl.startsWith('#') && !/^https?\:\/\//.test(editUrl)) {
			editUrl = `http://${editUrl}`;
		}

		this.setState({ editUrl, isValid });
	};

	handleKeyDown = evt => {
		if (evt.keyCode === 13) {
			evt.stopPropagation();
			evt.preventDefault();
			this.save();
		} else if (evt.keyCode === 27) {
			evt.stopPropagation();
			evt.preventDefault();
			this.dismiss();
		}
	};

	active = (url, buttonPosition) => {
		this.setState({ actived: url || true, editUrl: url, buttonPosition }, () => {
			this.inputElement && this.inputElement.select();
		});
	};

	save = () => {
		const { actived, editUrl: url, isValid } = this.state;

		if (actived === url) {
			this.dismiss();
			return;
		}

		if (isValid) {
			this.props.onSave(url);
			this.dismiss();
		} else {
			this.setState({ showValidationError: true }, () => {
				this.inputElement && this.inputElement.select();
			});
		}
	};

	dismiss = () => {
		this.setState({ actived: false, showValidationError: false });
	};

	handleClickOutside = () => this.dismiss();
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/linkPlugin/EditLinkBar.jsx